import { gql } from '@apollo/client';
import { Col, Form, Input, Row, Select } from 'antd';
import NumberInput from 'components/NumberInput';
import SettingsDrawer from 'components/Settings/SettingsDrawer';
import { useMutation } from 'hooks/apollo';
import React from 'react';
import { LICENSE_SETTINGS } from 'shared/constants/settings';
import { LicenseStatus } from 'shared/prisma/types';

const UPDATE_LICENSE = gql`
  mutation UpdateLicense($id: ID!, $input: LicenseInput!) {
    updateLicense(id: $id, input: $input) {
      id
      title
      uniqueTitle
      status
      level
    }
  }
`;

const CREATE_LICENSE = gql`
  mutation CreateLicense($input: LicenseInput!) {
    createLicense(input: $input) {
      id
      title
      uniqueTitle
      status
      level
    }
  }
`;

const EditLicenseForm = ({ license, onDone, onCreate }) => {
  const [updateLicense] = useMutation(UPDATE_LICENSE);
  const [createLicense] = useMutation(CREATE_LICENSE);

  const onSubmit = async (values) => {
    let { id } = license;
    if (id) {
      await updateLicense({ variables: { id, input: values } });
    } else {
      const res = await createLicense({ variables: { input: values } });
      id = res.data.createLicense.id;
      onCreate();
    }

    return id;
  };

  return (
    <SettingsDrawer
      title="Edit license details"
      settings={LICENSE_SETTINGS}
      initialValues={license}
      relationId={license?.id}
      open={!!license}
      onDone={onDone}
      onCancel={onDone}
      onSubmit={onSubmit}
    >
      <Form.Item name="title" label="Display title" rules={[{ required: true }]}>
        <Input />
      </Form.Item>
      <Form.Item name="uniqueTitle" label="Internal title">
        <Input />
      </Form.Item>
      <Row gutter={16}>
        <Col span={8}>
          <Form.Item name="status" label="Status" rules={[{ required: true }]}>
            <Select options={Object.values(LicenseStatus).map(s => ({ label: s, value: s }))} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item name="level" label="Level" rules={[{ required: true }]}>
            <NumberInput />
          </Form.Item>
        </Col>
      </Row>
    </SettingsDrawer>
  );
};

export default EditLicenseForm;
